import React from 'react';
import { SECURITY_ACTIONS } from '../../../auth/Security';
import { SIDE_PANEL_IDS } from '../../../constants/constants';
import I18n from '../../../i18n/I18n';
import { Icons } from '../../../icons/Icons';
import type { SidePanelDeclaration, SidePanelDefinition, SidePanelPresetConfiguration } from '../../types';
import { AttributesSidePanel } from './AttributesSidePanel';
import type { AttributesPanelOptions } from './types';

const definition: SidePanelDefinition = {
    id: SIDE_PANEL_IDS.attributes,
    kind: 'entity',
    icon: Icons.ResourceFields,
    label: <I18n token="attributes.title" />,
    affordancePermission: { securityAction: SECURITY_ACTIONS.EDIT },
    Component: AttributesSidePanel
};

export function attributesPanel(
    declarationConfiguration: SidePanelPresetConfiguration<AttributesPanelOptions> = {}
): SidePanelDeclaration {
    const declaration: SidePanelDeclaration = {
        definition: { ...definition, ...declarationConfiguration.definition },
        hidden: declarationConfiguration.hidden,
        enabled: declarationConfiguration.enabled,
        options: declarationConfiguration.options
    };
    return declaration;
}
